module.exports = __webpack_public_path__ + "img/frame2.fbca5e85.jpg";